import styled from "styled-components";


export const VideoSlidesSoundIconBox = styled.div`
  color: ${props => props.theme.colors.buttonLight};
  display: flex;
  justify-content: center;
  width: 40px;
  margin-bottom: 12px;

  &:focus {
    outline: none;
  }
  
  svg:focus {
    outline: none;
  }
`;